import React from 'react'
import styled from 'styled-components/macro'
import CrowsNestFunnelStats from './CrowsNestFunnelStats'
import CrowsNestLadderCensus from './CrowsNestLadderCensus'
import CrowsNestNorthStarWidget from './CrowsNestNorthStarWidget'
import CrowsNestOllieFindings from './CrowsNestOllieFindings'
import CrowsNestOpportunityFeed from './CrowsNestOpportunityFeed'
import CrowsNestTimeToConversion from './CrowsNestTimeToConversion'
import CrowsNestUnadoptedVenues from './CrowsNestUnadoptedVenues'

/**
 * Crow’s Nest panel — Growth Engine sales metrics for The Bridge.
 */
const CrowsNest = ({ onCreateDeal } = {}) => (
  <Panel data-testid='crows-nest'>
    <Intro>
      <Title>Crow&apos;s Nest</Title>
      <Body>
        Boringly clear Growth KPI: Free venues that hit a premium paywall hard
        enough to create a sales opportunity — then act on the feed and spot
        where the ladder leaks.
      </Body>
    </Intro>
    <CrowsNestNorthStarWidget />
    <CrowsNestLadderCensus />
    <CrowsNestFunnelStats />
    <CrowsNestTimeToConversion />
    <CrowsNestOllieFindings />
    <CrowsNestUnadoptedVenues />
    <CrowsNestOpportunityFeed onCreateDeal={onCreateDeal} />
  </Panel>
)

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg || '24px'};
  padding: ${({ theme }) => theme.spacing.md || '16px'} 0;
`

const Intro = styled.div`
  max-width: 40rem;
`

const Title = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing.sm || '8px'};
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colours.broccoliGreen || '#1a1a1a'};
`

const Body = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colours.stormGrey || '#666'};
  line-height: 1.5;
`

export default CrowsNest
